module.exports = __webpack_public_path__ + "static/media/banesco-headset.bd3fcc3d.svg";